export default __webpack_public_path__ + "assets/images/fc8702823e7224091459c13d236982fc.jpeg";